var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 362,
    viewBox: "0 0 365 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.4573 319.448L317.544 298.796L52.6029 220.388C82.6233 218.276 246.217 209.418 280.6 206.955C314.983 204.492 89.6695 162.048 34.3159 144.007L243.628 126.988C218.412 121.635 101.153 67.0455 83.4031 14.3434",
    stroke: "#56183E",
    strokeWidth: 64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317 176.659C317 215.267 285.693 246.529 247.085 246.529C208.477 246.529 177.215 215.267 177.215 176.659C177.215 138.051 208.477 106.744 247.085 106.744C285.693 106.744 317 138.051 317 176.659Z",
    stroke: "#F8D3C9",
    strokeWidth: 4.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.537 42.5624C152.537 42.5624 145.236 30.559 156.478 19.9889C167.72 9.46363 166.287 15.7788 169.109 16.4954C171.93 17.212 181.067 5.97012 192.981 11.5687C204.939 17.212 218.331 26.4833 209.194 42.5624C200.013 58.6414 199.341 55.8198 207.761 69.1667C216.181 82.5137 205.656 98.6824 202.834 110.641C200.013 122.555 192.309 128.198 185.994 129.586C179.634 130.975 145.953 153.459 138.921 154.892C131.889 156.28 121.364 160.491 114.332 161.207C107.3 161.879 96.0585 154.892 87.6382 162.596C79.218 170.344 81.3231 179.481 84.1 187.901C65.1544 164.029 68.6479 149.965 75.6797 142.217C82.7115 134.513 85.5332 138.723 88.3549 133.08C91.1318 127.481 81.323 119.061 97.4469 107.103C113.616 95.1889 121.364 112.029 129.784 107.819C138.205 103.609 126.291 80.4087 137.488 62.8516C148.73 45.2945 152.537 42.5624 152.537 42.5624Z",
    fill: "url(#paint0_linear_208_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.646 96.5778C120.646 96.5778 126.962 121.122 138.428 134.424C143.668 140.471 149.938 144.188 157.194 142.217C161.404 148.532 147.34 154.892 147.34 154.892C147.34 154.892 164.181 170.344 178.245 164.701C192.308 159.103 198.623 141.545 198.623 141.545C198.623 141.545 189.486 138.007 186.665 128.87C183.888 119.733 184.56 112.03 184.56 112.03C184.56 112.03 199.34 95.8611 189.486 86.0525C179.633 76.199 178.961 95.1893 178.961 95.1893L137.487 74.8105L124.14 78.304L120.646 96.5778Z",
    fill: "#F8D3C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.437 162.596L146.624 149.249C146.624 149.249 153.79 165.865 173.318 164.029C192.846 162.148 198.624 139.754 199.34 136.395L233.021 154.892L249.548 193.59L251.295 244.111L127.679 246.216L103.09 223.016L119.93 175.943L116.437 162.596Z",
    fill: "url(#paint1_linear_208_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.654 165.955C251.654 165.955 268.852 175.943 280.094 198.427C291.336 220.91 302.578 246.888 285.738 256.025C268.852 265.162 226.035 211.057 222.496 197.71C219.003 184.363 237.276 164.343 251.654 165.955Z",
    fill: "#F8D3C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240.367 201.606C240.367 201.606 251.699 177.062 263.433 175.45C263.433 175.45 257.073 168.239 254.52 167.522C252.012 166.806 241.576 174.913 241.576 174.913C241.576 174.913 240.77 177.062 239.382 179.66C237.949 182.258 234.097 187.901 234.097 187.901L240.367 201.606Z",
    fill: "#F8D3C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.82 246.215L48 243.394",
    stroke: "#350E28",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.576 276.269C131.576 276.269 75.0079 281.33 74.2913 283.435C73.5747 285.54 76.3963 292.572 76.3963 292.572L51.0908 296.065L77.1129 319.266L70.0812 324.148C70.0812 324.148 80.6065 336.106 128.396 327.686C176.14 319.266 197.908 308.024 202.834 296.065C207.761 284.107 201.446 282.002 201.446 282.002C201.446 282.002 210.359 266.057 192.891 266.684C175.424 267.266 131.576 276.269 131.576 276.269Z",
    fill: "url(#paint2_linear_208_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.633 95.189C179.633 95.189 179.633 100.071 176.14 103.609C176.14 103.609 178.245 94.4724 169.108 91.6507C159.971 88.829 152.939 95.8608 142.414 95.189C131.888 94.4724 124.498 80.3192 124.498 80.3192C124.498 80.3192 121.184 97.3837 123.737 104.371C123.737 104.371 111.51 94.4724 113.615 79.6922C115.72 70.6001 118.542 68.495 120.647 64.2401C122.752 60.03 122.035 53.7148 129.783 51.6098C137.487 49.5047 138.204 50.8931 138.204 50.8931C138.204 50.8931 142.414 44.578 148.729 43.1895C155.089 41.8011 155.761 43.1895 158.582 41.8011C161.404 40.3678 162.345 38.9794 168.884 41.8011C175.423 44.578 178.245 50.2213 181.783 51.6098C185.276 52.9982 187.381 59.3582 188.77 64.2401C190.203 69.1669 190.875 67.0618 193.697 70.6001C196.518 74.0936 198.623 79.0204 195.802 84.6189C192.98 90.2623 192.98 90.2623 192.98 90.2623C192.98 90.2623 183.171 78.3037 179.633 95.189Z",
    fill: "url(#paint3_linear_208_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.647 164.029C120.647 164.029 99.5967 172.449 82.7114 199.815C65.8709 227.225 68.6478 239.856 74.2912 244.782C79.8898 249.709 105.195 261.668 114.332 264.444C123.469 267.266 153.656 254.636 154.373 248.992C155.09 243.394 131.889 220.193 121.364 217.416C121.364 217.416 132.606 206.175 135.383 194.933C138.204 183.691 135.383 159.774 120.647 164.029Z",
    fill: "#F8D3C9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M261.82 166.806C247.085 169.717 237.321 196.994 224.108 201.607C205.611 175.226 199.296 159.774 216.136 146.427C229.304 136.036 261.82 166.806 261.82 166.806Z",
    fill: "url(#paint4_linear_208_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.876 112.029C190.876 115.119 188.368 117.628 185.277 117.628C182.187 117.628 179.634 115.119 179.634 112.029C179.634 108.939 182.187 106.386 185.277 106.386C188.368 106.386 190.876 108.939 190.876 112.029Z",
    fill: "#350E28"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.907 196.277V260.996C249.907 269.103 243.323 275.687 235.171 275.687H218.241C210.134 275.687 203.551 269.103 203.551 260.996V196.277C203.551 188.17 210.134 181.586 218.241 181.586H235.171C243.323 181.586 249.907 188.17 249.907 196.277ZM219.674 200.756C219.674 199.546 219.182 198.427 218.376 197.62C217.569 196.814 216.494 196.321 215.24 196.321C212.822 196.321 210.806 198.292 210.806 200.756V259.339C210.806 261.758 212.822 263.773 215.24 263.773C217.704 263.773 219.674 261.758 219.674 259.339V200.756Z",
    fill: "#56183E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.107 199.412V262.429C221.107 270.357 231.633 257.323 231.633 249.396V208.324C231.633 200.397 221.107 191.484 221.107 199.412Z",
    fill: "#350E28"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.963 184.139H226.304C224.96 184.139 223.93 183.064 223.93 181.765V174.106C223.93 172.807 224.96 171.732 226.304 171.732H236.963C238.307 171.732 239.382 172.807 239.382 174.106V181.765C239.382 183.064 238.307 184.139 236.963 184.139Z",
    fill: "#350E28"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4609 257.055C96.4609 257.055 131.441 276.269 141.16 278.777C150.834 281.33 167.003 294.677 174.035 293.961C181.066 293.244 177.215 285.854 177.215 285.854C177.215 285.854 180.35 290.467 184.56 286.257C188.77 282.002 184.56 279.046 184.56 279.046C184.56 279.046 189.487 285.54 193.697 279.897C197.235 278.509 198.624 278.509 199.34 274.298C200.012 270.088 184.784 251.098 172.378 246.216C159.971 241.289 156.478 241.289 156.478 241.289L144.519 223.016C144.519 223.016 108.061 232.108 96.4609 257.055Z",
    fill: "#350E28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.715 219.521C259.715 219.521 245.696 213.878 230.244 215.983C214.792 218.088 209.866 220.91 210.582 227.942C211.254 234.973 213.359 234.973 213.359 234.973C213.359 234.973 210.448 237.84 210.493 242.363C210.582 246.887 213.359 248.32 213.359 248.32C213.359 248.32 210.582 250.425 211.971 255.307C213.359 260.234 215.464 260.951 215.464 260.951C215.464 260.951 212.239 264.041 214.568 267.4C216.897 270.759 230.916 267.266 240.77 268.654C250.623 270.088 256.491 272.685 262.313 268.923C262.313 268.923 281.527 276.403 289.231 264.444C296.979 252.53 301.189 218.088 259.715 219.521Z",
    fill: "#350E28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.195 105.983C161.046 108.178 160.822 110.283 159.748 110.686C158.673 111.089 157.105 109.7 156.254 107.506C155.448 105.356 155.627 103.251 156.702 102.848C157.777 102.4 159.344 103.833 160.195 105.983Z",
    fill: "#350E28"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.816 113.732C140.667 115.882 140.443 117.987 139.369 118.435C138.294 118.838 136.726 117.405 135.875 115.255C135.069 113.06 135.248 110.955 136.323 110.552C137.443 110.149 138.965 111.537 139.816 113.732Z",
    fill: "#350E28"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142.056 107.461C142.056 107.461 142.772 122.913 144.877 123.63C146.982 124.301 149.759 123.63 149.759 123.63",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M148.058 129.631C148.058 129.631 150.028 130.885 156.03 129.049C161.987 127.213 170.542 116.956 170.542 116.956H169.691",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.477 98.9507C150.477 98.9507 152.94 95.8603 157.195 95.1885",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.263 103.744C137.263 103.744 133.725 101.952 129.604 103.027",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.382 91.6504C187.382 91.6504 183.889 96.5771 183.889 102.176",
    stroke: "#350E28",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.77 100.071C188.77 100.071 187.203 97.1597 184.471 97.9211",
    stroke: "#350E28",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.866 142.216C157.866 142.216 170.183 140.111 177.215 127.929C176.14 140.604 168.436 147.501 157.866 147.322C159.299 144.187 157.866 142.216 157.866 142.216Z",
    fill: "#56183E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 175.227C101.701 175.227 115.72 197.039 129.784 203.354",
    stroke: "#1D1D1B",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.788 280.076C144.788 280.076 158.672 287.198 166.018 291.632C173.318 296.066 181.067 293.916 177.215 285.854C184.202 290.109 188.099 284.107 184.56 279.046C184.56 279.046 186.038 282.719 190.204 282.719C192.891 282.719 193.697 279.897 193.697 279.897C193.697 279.897 199.072 279.808 199.206 274.926C199.341 270.089 195.713 266.685 195.713 266.685",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.972 267.983C159.972 267.983 174.752 280.569 177.215 285.854",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.286 260.951C166.286 260.951 179.633 271.163 184.56 279.046",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M178.514 258.488C178.514 258.488 192.309 269.372 193.697 279.897",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.478 241.289C156.478 241.289 142.28 242.14 135.696 245.902",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M249.19 216.656C249.19 216.656 230.245 213.386 216.898 218.895C203.551 224.404 213.36 234.974 213.36 234.974C213.36 234.974 207.044 242.678 213.36 248.321C208.478 254.636 215.465 260.951 215.465 260.951C215.465 260.951 211.702 265.744 215.689 268.252C219.675 270.76 231.544 267.401 237.545 268.386C243.592 269.372 257.924 272.686 262.313 268.924",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M242.741 257.054C242.741 257.054 221.825 256.024 215.465 260.951",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M239.382 244.111C239.382 244.111 217.569 243.394 213.359 248.321",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M242.875 229.331C242.875 229.331 221.108 228.614 213.359 234.974",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M265.762 229.33C265.762 229.33 272.39 246.887 268.852 255.307",
    stroke: "#56183E",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M227.781 174.912V181.496",
    stroke: "#56183E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M232.305 174.912V181.496",
    stroke: "#56183E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M236.111 174.912V181.496",
    stroke: "#56183E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.499 80.3194L121.364 74.0938C121.364 74.0938 113.436 91.0686 123.738 104.371C123.2 86.6793 124.499 80.3194 124.499 80.3194Z",
    fill: "url(#paint5_linear_208_2)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M191.368 68.4049C191.368 68.4049 186.666 71.4953 179.634 66.1206C179.634 66.1206 189.084 67.5091 188.233 62.3584",
    fill: "url(#paint6_linear_208_2)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M181.336 51.0725C181.336 51.0725 177.797 55.417 169.467 52.4162C169.467 52.4162 178.872 50.8934 176.543 46.2354",
    fill: "url(#paint7_linear_208_2)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M138.204 50.8934C138.204 50.8934 139.055 52.5057 142.862 53.4463C146.624 54.4317 149.043 52.1922 149.043 52.1922C149.043 52.1922 140.712 50.0424 142.638 46.2354",
    fill: "url(#paint8_linear_208_2)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M178.693 81.8409C174.886 75.5705 171.214 76.9142 158.583 76.1975C146.759 75.5257 145.953 68.0908 145.908 67.1055C145.953 67.7325 146.266 71.6739 149.76 75.6153C153.567 79.915 162.077 79.8254 162.077 79.8254C160.061 80.1837 157.822 80.542 155.269 80.9003C142.101 82.7815 135.383 69.8824 135.383 69.8824C135.383 69.8824 135.383 72.704 139.593 78.3026C143.848 83.946 154.373 83.946 162.077 83.2293C169.825 82.5127 174.752 84.6178 177.215 91.6496C179.634 98.6814 176.14 103.608 176.14 103.608C180.798 100.249 182.321 86.7676 178.693 81.8409Z",
    fill: "url(#paint9_linear_208_2)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6699 136.619C94.6699 136.619 116.572 135.185 124.857 137.335C133.143 139.44 137.264 133.797 137.264 133.797L132.471 125.914C132.471 125.914 131.173 133.304 118.542 131.692C105.912 130.079 94.6699 136.619 94.6699 136.619Z",
    fill: "url(#paint10_linear_208_2)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M84.099 187.901C84.099 187.901 72.9915 168.239 75.0069 157.938C77.112 147.144 89.7424 136.619 105.911 140.829C122.035 145.039 122.035 145.039 122.035 145.039C122.035 145.039 106.225 130.93 83.6063 137.649C60.9433 144.322 72.1853 178.182 83.4272 187.23",
    fill: "url(#paint11_linear_208_2)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3564 109.656C94.3564 109.656 103.269 103.609 110.57 107.461C117.826 111.313 128.217 117.628 128.217 117.628L124.32 108.088C124.32 108.088 110.883 93.9799 94.3564 109.656Z",
    fill: "url(#paint12_linear_208_2)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M150.207 34.0075C150.207 34.0075 157.597 19.2273 162.3 21.0189C167.003 22.8104 167.63 28.3642 175.378 24.8707C183.171 21.422 188.77 13.7183 198.623 19.3169C208.477 24.9155 212.194 31.9473 212.194 31.9473C212.194 31.9473 214.075 20.7053 192.98 11.5685C181.066 8.07497 175.423 16.4952 169.108 16.4952C162.793 16.4952 167.316 14.3006 165.032 13.9871C162.793 13.6735 150.968 22.0042 150.207 34.0075Z",
    fill: "url(#paint13_linear_208_2)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M121.364 217.417C121.364 217.417 111.734 214.147 106.001 215.043",
    stroke: "#350E28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2365 185.438C93.2365 185.438 108.017 198.785 115.72 205.279C123.469 211.773 122.752 215.984 122.752 215.984L133.322 203.353C133.322 203.353 120.692 183.243 113.302 176.794C105.912 170.344 93.2365 185.438 93.2365 185.438Z",
    fill: "#F8D3C9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2363 176.66C93.2363 176.66 111.062 205.503 130.948 211.46C149.446 185.08 155.761 169.628 138.921 156.281C125.753 145.89 93.2363 176.66 93.2363 176.66Z",
    fill: "url(#paint14_linear_208_2)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M147.341 159.102C147.341 159.102 155.492 179.077 171.795 176.435C188.098 173.837 201.445 147.322 201.445 147.322C201.445 147.322 190.383 170.523 172.378 169.358C154.373 168.239 147.341 159.102 147.341 159.102Z",
    fill: "url(#paint15_linear_208_2)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M135.383 211.057C135.383 211.057 154.955 236.183 171.214 233.54C187.517 230.943 193.697 223.015 193.697 223.015C193.697 223.015 187.114 227.673 169.109 226.509C151.104 225.389 135.383 211.057 135.383 211.057Z",
    fill: "url(#paint16_linear_208_2)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M147.341 156.997C147.341 156.997 152.447 170.523 172.378 169.359C192.309 168.239 201.446 146.427 201.446 146.427",
    stroke: "#350E28",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M195.802 281.33C195.802 281.33 197.236 300.276 152.268 308.696C107.3 317.161 100.268 315.056 100.268 315.056L79.2178 318.549C79.2178 318.549 138.204 304.799 159.613 298.663C181.067 292.572 195.802 281.33 195.802 281.33Z",
    fill: "url(#paint17_linear_208_2)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0283 292.214L157.329 287.466L146.49 281.688L95.0283 292.214Z",
    fill: "url(#paint18_linear_208_2)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M292.769 121.525C292.769 134.11 282.513 144.322 269.927 144.322C257.297 144.322 247.085 134.11 247.085 121.525C247.085 108.894 257.297 98.6826 269.927 98.6826C282.513 98.6826 292.769 108.894 292.769 121.525Z",
    fill: "url(#paint19_linear_208_2)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3369 62.359L99.5968 69.2564L106.002 34.0078L77.3369 62.359Z",
    fill: "url(#paint20_linear_208_2)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M220.122 50.5797L224.959 43.5479L229.169 49.863L234.275 43.5479L238.306 49.863L242.516 43.5479L246.726 49.863L251.653 43.5479L256.58 49.863L260.924 43.5479",
    stroke: "#350E28",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M220.839 40.1436H261.596",
    stroke: "#F8D3C9",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6599 206.847H51.0898V196.321H61.6599V206.847Z",
    fill: "url(#paint21_linear_208_2)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6609 223.016H51.0908V212.49H61.6609V223.016Z",
    stroke: "#350E28",
    strokeWidth: 3.1,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_2",
    x1: 70.0744,
    y1: 9.99572,
    x2: 212.219,
    y2: 9.99572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_2",
    x1: 215.306,
    y1: 122.01,
    x2: 239.434,
    y2: 258.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_2",
    x1: 51.1056,
    y1: 266.657,
    x2: 204.709,
    y2: 266.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_208_2",
    x1: 113.379,
    y1: 40.1591,
    x2: 197.138,
    y2: 40.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_208_2",
    x1: 206.352,
    y1: 144.308,
    x2: 261.817,
    y2: 144.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_208_2",
    x1: 42.4477,
    y1: 84.3602,
    x2: 52.3142,
    y2: 50.9233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_208_2",
    x1: 215.022,
    y1: 78.0554,
    x2: 133.73,
    y2: 55.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_208_2",
    x1: 223.878,
    y1: 67.5677,
    x2: 135.016,
    y2: 42.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_208_2",
    x1: 223.895,
    y1: 76.7565,
    x2: 139.012,
    y2: 53.1293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_208_2",
    x1: 170.319,
    y1: 65.5092,
    x2: 202.38,
    y2: 86.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_208_2",
    x1: 94.6578,
    y1: 125.92,
    x2: 137.284,
    y2: 125.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_208_2",
    x1: 70.4797,
    y1: 135.831,
    x2: 122.053,
    y2: 135.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_208_2",
    x1: 94.3354,
    y1: 102.254,
    x2: 128.23,
    y2: 102.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_208_2",
    x1: 150.217,
    y1: 10.7193,
    x2: 212.249,
    y2: 10.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_208_2",
    x1: 93.2525,
    y1: 154.143,
    x2: 148.718,
    y2: 154.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_208_2",
    x1: 185.422,
    y1: 165.554,
    x2: 178.147,
    y2: 191.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_208_2",
    x1: 182.667,
    y1: 240.435,
    x2: 106.614,
    y2: 217.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_208_2",
    x1: 119.138,
    y1: 287.577,
    x2: 167.357,
    y2: 263.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_208_2",
    x1: 119.06,
    y1: 284.837,
    x2: 143.127,
    y2: 272.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_208_2",
    x1: 247.091,
    y1: 98.6795,
    x2: 292.751,
    y2: 98.6795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_208_2",
    x1: 77.3495,
    y1: 33.9912,
    x2: 106.01,
    y2: 33.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_208_2",
    x1: 51.1046,
    y1: 196.321,
    x2: 61.6416,
    y2: 196.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F1F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.bd3180b76ca592742ef1508b38600526.svg";
export { ForwardRef as ReactComponent };